export const TEST_IDS = {
  // Navigation & Header
  brandLogo: "brand-logo",
  navDashboard: "nav-dashboard-link",
  navCalendar: "nav-calendar-link",
  navBookings: "nav-bookings-link",
  navBusinessSetup: "nav-business-setup-link",
  navCategoryBadge: "nav-category-badge",
  userMenuBtn: "user-menu-button",
  logoutBtn: "logout-button",
  demoSwitchBtn: "demo-switch-button",

  // Category Selection Onboarding
  categoryModal: "category-onboarding-modal",
  categoryOptionConventionHall: "category-option-convention-hall",
  categoryOptionCatering: "category-option-catering-services",
  categoryOptionPlanner: "category-option-event-planner",
  categoryOptionDecoration: "category-option-decoration",
  categoryOptionPhotography: "category-option-photography-videography",
  categoryConfirmBtn: "category-confirm-button",

  // Business Setup
  setupModal: "business-setup-modal",
  setupBizNameInput: "setup-business-name-input",
  setupContactPersonInput: "setup-contact-person-input",
  setupPhoneInput: "setup-phone-input",
  setupAddressInput: "setup-address-input",
  setupCityInput: "setup-city-input",
  setupCapacityGuestsInput: "setup-capacity-guests-input",
  setupDaySlotRateInput: "setup-day-slot-rate-input",
  setupNightSlotRateInput: "setup-night-slot-rate-input",
  setupFullDayRateInput: "setup-full-day-rate-input",
  setupSaveBtn: "setup-save-button",
  setupCloseBtn: "setup-close-button",

  // Dashboard & Action
  btnNewBooking: "new-booking-button",
  btnSeedDemoData: "seed-demo-data-button",
  viewToggleCalendar: "view-toggle-calendar",
  viewToggleList: "view-toggle-list",
  statTotalBookings: "stat-total-bookings",
  statConfirmedBookings: "stat-confirmed-bookings",
  statRevenue: "stat-revenue",
  statPendingBalance: "stat-pending-balance",

  // Calendar
  calendarContainer: "availability-calendar-container",
  calendarPrevMonthBtn: "calendar-prev-month-button",
  calendarNextMonthBtn: "calendar-next-month-button",
  calendarMonthTitle: "calendar-month-title",
  calendarDayCell: (dateStr) => `calendar-day-cell-${dateStr}`,
  selectedDateDrawer: "selected-date-drawer",
  selectedDateTitle: "selected-date-title",
  selectedDateBookingsList: "selected-date-bookings-list",
  btnBookThisDate: "book-this-date-button",

  // New Booking Modal
  bookingModal: "booking-modal",
  bookingTypeSingleDayRadio: "booking-type-single-day-radio",
  bookingTypeMultiDayRadio: "booking-type-multi-day-radio",
  slotTypeDayRadio: "slot-type-day-radio",
  slotTypeNightRadio: "slot-type-night-radio",
  slotTypeFullDayRadio: "slot-type-full-day-radio",
  slotTypeCustomRadio: "slot-type-custom-radio",
  clientNameInput: "client-name-input",
  clientPhoneInput: "client-phone-input",
  clientEmailInput: "client-email-input",
  eventTypeSelect: "event-type-select",
  startDateInput: "start-date-input",
  endDateInput: "end-date-input",
  startTimeInput: "start-time-input",
  endTimeInput: "end-time-input",
  totalAmountInput: "total-amount-input",
  advancePaidInput: "advance-paid-input",
  guestCountInput: "guest-count-input",
  notesInput: "notes-input",
  availabilityStatusBanner: "availability-status-banner",
  dateUnavailableAlert: "date-unavailable-alert",
  dateAvailableNotice: "date-available-notice",
  submitBookingBtn: "submit-booking-button",
  cancelBookingBtn: "cancel-booking-button",

  // Bookings List
  bookingsListTable: "bookings-list-table",
  searchInput: "bookings-search-input",
  statusFilterSelect: "status-filter-select",
  bookingTypeFilterSelect: "booking-type-filter-select",
  bookingRow: (id) => `booking-row-${id}`,
  btnViewBooking: (id) => `btn-view-booking-${id}`,
  btnDeleteBooking: (id) => `btn-delete-booking-${id}`,
  
  // Auth
  loginContainer: "login-container",
  btnGoogleSignIn: "btn-google-sign-in",
  btnDemoLogin: "btn-demo-login",
  signInTab: "sign-in-tab",
  signUpTab: "sign-up-tab"
};
